export default {
  getFeedEmOrderLine: (state) => state.feedEmOrderLine,
};
